export default __webpack_public_path__ + "static/media/Arquivo CSV.3967f049.svg";